import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';

import dev from '@topdesk/translations__odata-ui/dev.json';

const importTranslation = async (bundleName: string) => {
	const translations = await import(`../../node_modules/@topdesk/translations__odata-ui/${bundleName}.json`);
	return { ...dev, ...translations.default };
};

/** Some Json files are incomplete and require a fallback Json to be loaded */
const BundleFallbacks: Record<string, string> = {
	'en-US': 'en', /* US English requires the British as a fallback */
	'pt': 'pt-BR', /* Portugal Portuguese requires the Brazilian dialect as a fallback */
};
const bundleNameOf = (locale: string) => locale === 'en-GB' ? 'en' : locale;

const enGB = { ...dev };

export const i18n = createI18n({
	// Jest doesn't know about the __VUE_I18N_LEGACY_API__ build flag already disabling legacy mode
	legacy: false,
	locale: 'en-GB',
	fallbackLocale: 'en-GB',
	// Unfortunately our 'Adjustable names' system syntax (eg. '$<person_singular>$') causes false positives
	warnHtmlMessage: false,
});

i18n.global.setLocaleMessage('en-GB', enGB);
document.documentElement.setAttribute('lang', 'en-GB');

type FetchTranslationsOptions = {
	/** Name of the resource bundle to load in case it's not the same as the locale */
	bundleName?: string;
};

/** Lazy-load translations then update the locale */
export async function updateLanguage(locale: string, { bundleName = bundleNameOf(locale) }:
FetchTranslationsOptions = {}) {
	const translation = await importTranslation(bundleName);
	const bundleFallback = BundleFallbacks[bundleName] ?? null;
	const translationFallback = bundleFallback ? await importTranslation(bundleFallback) : {};
	const translationResolved = { ...translationFallback, ...translation };

	i18n.global.setLocaleMessage(locale, translationResolved);
	await nextTick();
	document.documentElement.setAttribute('lang', locale);
	i18n.global.locale.value = locale;
}
